<div class="bg-th-blue mt-0 container-fluid py-2 position-sticky top-0 index-3">
    <div class=" d-flex justify-content-between  align-content-center">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>
        <p class="text-white my-2">گزارش حضور در محدوده </p>
    </div>
</div>
<div class="col-12 d-flex justify-content-around dirI flex-wrap">
    <div class="col-xl-2 col-lg-4 col-6">
        <div class="col-11 mx-auto">
            <label class="mb-2">محدوده</label>
            <select class="form-select " id="areaSelection" #mahdude>
                <option value="-1">انتخاب کنید</option>
                <option *ngFor="let item of GeoFenceData" value="{{item.iGeoFence}}">
                    {{item.strTitle}}</option>
            </select>
        </div>
    </div>
    <div class="col-xl-2 col-lg-4 col-6">
        <div class="col-11 mx-auto">
            <label class="mb-2"> حوزه خدمت</label>
            <select class="form-select" id="domainDashbord" #hoze>
                <option value="-1">انتخاب کنید</option>
                <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>
            </select>
        </div>
    </div>
    <div class="col-xl-2 col-lg-4 col-6">
        <div class="col-11 mx-auto">
            <label class="mb-2"> تاریخ </label>
            <form [formGroup]="datatFrom">
                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateFormat]="'jYYYY/jMM/jDD'">
                    <input type="text" id="strDate" formControlName="strDate" class="form-control shadow text-end"
                        readonly />
                </ng-persian-datepicker>
            </form>

        </div>
    </div>

    <div class="col-xl-2 col-lg-4 col-6">
        <div class="col-11 mx-auto ">
            <label class="w-100 mb-2"> ساعت شروع </label>
            <div class="input-group clockpicker">
                <input type="text" class="form-control shadow bg-light" value="00:00" id="sTime" readonly>
                <span class="input-group-addon ">
                    <span class="glyphicon glyphicon-time"></span>
                </span>
            </div>
        </div>
    </div>

    <div class="col-xl-2 col-lg-4 col-6">
        <div class="col-11 mx-auto ">
            <label class="w-100 mb-2"> ساعت پایان </label>
            <div class="input-group clockpicker">
                <input type="text" class="form-control shadow bg-light" value="23:59" id="eTime" readonly>
                <span class="input-group-addon ">
                    <span class="glyphicon glyphicon-time"></span>
                </span>
            </div>
        </div>
    </div>

    <div class="col-xl-2 col-lg-4 col-6 align-items-end d-flex">
        <div class="col-11 mx-auto d-flex gap-2 justify-content-start">
            <button class="btn btn-primary pointer" (click)="searchBtn()" title="جستجو"><i class="fa fa-search fa-lg"></i></button>
            <button [ngClass]="mahdude.value != '-1'? 'd-block': 'd-none'" class="btn btn-danger pointer" (click)="deleteBtn()" title="حذف تحلیل های قبلی"><i
                    class="fa fa-refresh fa-lg"></i></button>
            <button class="btn btn-success pointer" (click)="exportexcel()" title="خروجی اکسل"><i
                    class="fa fa-file-excel-o fa-lg"></i></button>
            <button printTitle="گزارش حضور در محدوده" printSectionId="print-table-areaPresence"
                class="btn btn-secondary pointer" [useExistingCss]="true" title="چاپ" ngxPrint><i
                    class="fa fa-print fa-lg"></i></button>
        </div>
    </div>
</div>
<div class="col-12 d-flex dirI">
    <div class="col-lg-4 col-md-6 col-10 dirI mt-3 ms-4">
        <input type="text" class="form-control" (keyup)="filter($event.target)" placeholder="بر اساس نام خودرو">
    </div>
    <div class="d-flex justify-content-end align-items-end">
        <label>مجموع پیمایش : {{totalKM}}</label>
    </div>
</div>

<div class="table-responsive dirI rounded-3 my-2" style="max-height: 70vh; overflow-y: auto;"
    id="print-table-areaPresence">
    <table class="table table-striped mt-1 dirI" id="excel-table-saleryData" id="exelAreaReport">
        <thead class="">
            <tr class="text-center">
                <th scope="col" class=""># </th>
                <th scope="col" class="no-print">عملیات</th>
                <th scope="col" class="">نام محدوده </th>
                <th scope="col" class="">تاریخ </th>
                <th scope="col" class="pointer" (click)="sortBy()"><i class="fa fa-sort-amount-asc"></i>&nbsp;شماره
                    پرسنلی</th>
                <th scope="col" class="">نام خودرو </th>
                <th scope="col" class="">پلاک </th>
                <th scope="col" class="">حوزه خدمت </th>
                <th scope="col" class="" (click)="sortTime(1)">زمان اولین حضور </th>
                <th scope="col" class="" (click)="sortTime(2)">زمان آخرین حضور </th>
                <th scope="col" class="">پیمایش کل </th>
            </tr>
        </thead>
        <tbody>
            <tr class="text-center f14 dirI " *ngFor="let item of areaData;let i=index">
                <th class="">{{i+1}}</th>
                <th class="no-print" data-bs-toggle="modal" data-bs-target="#modalPolygan"
                    (click)="setId(item.strUnitID)"><img class="pointer" width="22" height="22"
                        src="../../../assets/Img/polygon-icon-28-min.png">
                </th>
                <th class="">{{item.strTitle}}</th>
                <th class="">{{item.strDate|faNum}}</th>
                <th class="">{{item.strPersonnelID |faNum}}</th>
                <th class="">{{item.strFullName}}</th>
                <th class="">{{otherService.returnCorrectPlate(item.strVehicleNo) | faNum }}</th>
                <th class="">{{item.strMobileDomain_strComment}}</th>
                <th class="">{{item.strFirstTime|faNum}}</th>
                <th class="">{{item.strLastTime|faNum}}</th>
                <th class="">{{item.fKM|faNum}}</th>
            </tr>

        </tbody>
    </table>
</div>
<!-- Modal analysis -->
<div class="modal fade dirI" style="z-index: 99999;" id="modalPolygan" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <!-- <button class="btn btn-primary" id="moveinArea" data-bs-toggle="modal" data-bs-target="#menuModal" (click)="hideTooltip()">حرکت داخل محدوده </button> -->

                <!-- <button class="btn btn-success" id="analysisArea" name="analysis" *ngIf="deviceInfo && acssess.bAnalysDomain">تحلیل در محدوده </button> -->

                <!-- <button class="btn btn-warning" id="enterExit" name="analysis">ورود و خروج </button> -->
                <!-- <button class="btn btn-info" id="">تخلف ورود </button>
                <button class="btn btn-danger" id=""> تخلف خروج </button> -->
                <div class="reportsView">
                    <button class="btn btn-th-blue w-200 mt-2" id="moveinArea" data-bs-toggle="modal"
                        data-bs-target="#menuModal">حرکت داخل محدوده <i class="fa fa-street-view"
                            aria-hidden="true"></i></button>
                    <button class="btn btn-th-blue w-200 mt-2" id="analysisArea" data-bs-toggle="modal"
                        data-bs-target="#exampleModalreportArea" name="analysis" (click)="setAnalysisId(2)">تحلیل در
                        محدوده <i class="fa fa-map" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                        data-bs-target="#exampleModalreportArea" id="enterExit" name="analysis"
                        (click)="setAnalysisId(1)">ورود و خروج <i class="fa fa-external-link" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-th-blue w-200 mt-2">تخلف ورود <i class="fa fa-sign-out"
                            aria-hidden="true"></i></button>
                    <button class="btn btn-th-blue w-200 mt-2">تخلف خروج <i class="fa fa-sign-in"
                            aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>

            </div>
        </div>
    </div>
</div>
<!-- Modal Menu-->
<div class="modal fade rtl " id="menuModal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="">بازه مد نظر خود را انتخاب کنید</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>
            <div class="modal-body d-flex justify-content-around">

                <form [formGroup]="dataPeriodTa">
                    <label> تاریخ</label>

                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'"
                        [dateFormat]="'jYYYY/jMM/jDD'">
                        <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                    </ng-persian-datepicker>
                </form>


            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" (click)="report()">تایید <i
                        class="fa fa-angle-double-down"></i>
                </button>
                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>

            </div>
        </div>
    </div>
</div>
<!--Report analysis-->
<div class="modal fade rtl " id="exampleModalreportArea" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">بازه مد نظر خود را انتخاب کنید</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex justify-content-around flex-wrap ">


                <div class="col-5 mb-2">
                    <label class="mb-2">از تاریخ* </label>
                    <form [formGroup]="dataWorkAz">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>

                </div>
                <div class="col-5 mb-2">
                    <label class="mb-2"> تا تاریخ *</label>
                    <form [formGroup]="dataWorkTa">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>

                </div>

                <div class=" col-5">
                    <label class="mb-2"> از ساعت *</label>
                    <div class="input-group clockpicker">
                        <input type="text" class="form-control shadow bg-light" value="00:00" id="clocks" readonly>
                        <span class="input-group-addon ">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>


                </div>
                <div class=" col-5">
                    <label class="mb-2"> تا ساعت *</label>
                    <div class="input-group clockpicker">
                        <input type="text" class="form-control shadow bg-light" value="23:59" id="clocke" readonly>
                        <span class="input-group-addon">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>

                </div>



            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" id="reporetArea">تایید <i
                        class="fa fa-angle-double-down"></i> </button>

                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>
            </div>
        </div>
    </div>
</div>